import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiShield, FiHome, FiHardDrive, FiUsers, FiClipboard, FiTrendingUp } = FiIcons;

const SERVICES = [
  { title: 'Safety Training', icon: FiShield, desc: 'Comprehensive safety courses for various industries ensuring workplace compliance.' },
  { title: 'Domestic Worker Settling-In', icon: FiHome, desc: 'Mandatory and supplementary programs for foreign domestic workers in Singapore.' },
  { title: 'Foreign Worker Site Safety', icon: FiHardDrive, desc: 'Induction and safety awareness programs specifically tailored for foreign construction workers.' },
  { title: 'Employer Consultation', icon: FiUsers, desc: 'Expert guidance for employers on workforce management, safety regulations, and compliance.' },
  { title: 'Workplace Compliance', icon: FiClipboard, desc: 'Audits and training to ensure your organization meets all national safety standards.' },
  { title: 'Workforce Development', icon: FiTrendingUp, desc: 'Upskilling programs designed to improve productivity and career progression.' },
];

const Services = () => {
  return (
    <section id="services" className="py-24 bg-white relative">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-alpha-green font-semibold tracking-wider uppercase mb-2 text-sm">Our Expertise</h2>
          <h3 className="text-3xl md:text-4xl font-bold text-alpha-navy mb-4">Enterprise-Grade Training Solutions</h3>
          <p className="text-lg text-alpha-grayDark">
            We provide a comprehensive suite of consulting and training services tailored to the unique needs of Singapore's diverse workforce.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {SERVICES.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group bg-white rounded-xl p-8 border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 border-b-4 hover:border-b-alpha-green relative overflow-hidden"
            >
              {/* Subtle A-shape background on hover */}
              <div className="absolute -right-10 -bottom-10 w-32 h-32 bg-alpha-green/5 mask-a-shape opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <div className="w-14 h-14 bg-alpha-navy/5 rounded-lg flex items-center justify-center mb-6 group-hover:bg-alpha-navy group-hover:text-white transition-colors duration-300">
                <SafeIcon icon={service.icon} className="text-2xl text-alpha-navy group-hover:text-white transition-colors" />
              </div>
              <h4 className="text-xl font-bold text-alpha-navy mb-3">{service.title}</h4>
              <p className="text-alpha-grayDark leading-relaxed">{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;